const block = document.querySelector('section.hero');

if(block) {
    let words = block.querySelectorAll('.anim-vertical span');
    let animLength = words.length * 3;
    words.forEach(function(word, index){
        word.style.animation =  'animUp ' + animLength  + 's linear infinite 0s';
        word.style.animationDelay = 3 * index + 's';
    });
}